/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { brandingsStore } from '../../axios/brandingsStore'
import type { BrandingsStoreError, BrandingsStoreRequest, BrandingsStoreResponse } from '../../types/BrandingsStore'

export const brandingsStoreMutationKey = () => [{ url: '/brandings' }] as const

export type BrandingsStoreMutationKey = ReturnType<typeof brandingsStoreMutationKey>

export type BrandingsStoreVariables = {
	data: BrandingsStoreRequest
}

/** @see backend/nexus/modules/Branding/Http/Controllers/BrandingController.php BrandingController::store */
export function useBrandingsStore<TContext = unknown>(
	options?: UseMutationOptions<
		BrandingsStoreResponse,
		AxiosError<BrandingsStoreError>,
		BrandingsStoreVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: brandingsStoreMutationKey(),
		mutationFn: ({ data }: BrandingsStoreVariables) => brandingsStore(data, config).then(res => res.data),
		...options,
	})
}
